export const isNull = (val: any): boolean => {
    return typeof val !== 'string'
  }
  
  export const isNotNull = (val: any): boolean => {
    return typeof val === 'string'
  }
  
  export const isEmpty = (val: any): boolean => {
    return isNull(val) || val.trim().length === 0
  }
  
  export const isNotEmpty = (val: any): boolean => {
    return isNotNull(val) && val.trim().length > 0
  }
  